<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mt-2"
        style="margin-right:0.5em;border-radius:8px;margin-top:-7px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-col cols="12" sm="12">
            <v-card class="box">
                <v-col cols="12" sm="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Publish Webinar
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                            <v-autocomplete dense required outlined rounded color="#0F2027" v-model="ay"
                                :items="ay_list" item-text="ay" item-value="id" label="Academic Year" persistent-hint
                                hint="Please select academic year" />
                        </v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 m-0" v-if="ay!=null">
                            <v-btn class="mt-6 button" :loading="loader" @click="getInstCourse">Proceed</v-btn>
                        </v-col>
                    </v-row>
                    <span v-if="instrructor_course_list!=''">
                        <v-data-table v-if="instrructor_course_list.length > 0" dense :headers="headers1"
                            :items="instrructor_course_list" :search="search" class="elevation-1 mytable">
                            <template v-slot:item.options="{ item }">
                                <v-btn small class="button"
                                    @click="getcourse_info(item.crs_off_id,item.crs_off_inst_id)">Proceed</v-btn>
                            </template>
                        </v-data-table>
                    </span>
                </v-col>
            </v-card>
        </v-col>
        <v-dialog v-model="dialog" fullscreen>
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Publish Course Webinar</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-btn class="toolbar" @click="dialog=false">Cancel</v-btn>
                        </v-toolbar>
                        <publish-webinar :webinarlist="webinarlist"></publish-webinar>
                    </v-card>
                </v-col>
                <v-row justify="center" dense>
                    <v-btn class="button mt-3" @click="dialog=false">Cancel</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Publish Webinar Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/V15AAN3sxII?si=C1MSzutsZ6dwHPds"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import PublishWebinar from "./PublishWebinar";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            "publish-webinar": PublishWebinar,
            Breadcrumbs
        },
        data() {
            return {
                load_comp:false,
                snackbar_msg: null,
                snackbar: false,
                loader: false,
                videoDialog:false,
                color: "",
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                ay_list: [],
                ay: null,
                search: null,
                dialog: false,
                rubricsScheme: null,
                instrructor_course_list: [],
                divisionoffering_id: null,
                crs_inst_id: null,
                headers1: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Course",
                        align: "center",
                        sortable: false,
                        value: "crs_name",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "standard",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "divisionoffering",
                    },
                    {
                        text: "Course Webinars Count",
                        align: "center",
                        sortable: false,
                        value: "webinarlist",
                    },
                    // {
                    //     text: "Course Type",
                    //     align: "center",
                    //     sortable: false,
                    //     value: "coursetype",
                    // },
                    {
                        text: "Action",
                        align: "center",
                        sortable: false,
                        value: "options",
                    },
                ],
                webinarlist:[]
            };
        },
        methods: {
            //  chnaged(dialog) {
            //     this.dialog = dialog;
            //     this.getcourse_info();
            // },
            getcourse_info(item, item2) {
               // alert(this.load_comp)
               // this.load_comp=false
               // alert(this.load_comp)
                this.$store.commit("setcoff_id", item);
                this.$store.commit("setcrs_off_inst_id", item2);
                this.$store.commit("setay", this.ay);
               
               this.webinarlist=[]
                const formData = {
                    coff_id: item,
                    crs_off_inst_id: item2,
                    ay: this.ay
                };
                axios
                    .post("/Webinar/getCourseWebinar", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.webinarlist = res.data.webinarlist;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                    });
                this.load_comp=true
                this.dialog = true;
                // this.$router.push({ name: 'publish-course-webinar'})
                // alert("1-"+this.load_comp)
            },
            getInstCourse() {
                this.loader = true;
                const data = {
                    ay: this.ay,
                };
                axios
                    .post("/Webinar/getInstCourse", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.instrructor_course_list = res.data.instrructor_course_list;
                            this.loader = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered.."); // show snackbar
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader = false;
                    })
                    .finally(() => {
                        //stop loader
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/examination/offerAssessmentScheme")
                    .then((res) => {
                        this.ay_list = res.data.ay_list;
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .box {
        background-color: white !important;
        margin: 8px !important;
        padding: 8px;
        border: 2px solid #0f2027 !important;
    }
    .toolbar {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        color: white;
    }
    .button {
        border: 2px solid #0f2027 !important;
        color: #0f2027;
        background: transparent !important;
        border-radius: 50px;
        margin: 0.5rem !important;
    }
    .button:hover {
        color: white;
        background: #0f2027 !important;
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
</style>
